import {createApp} from 'vue'
import StafetOpretHoldStepTwo from './StafetOpretHoldStepTwo'

const el = '.kb-component--stafet-opret-hold-step-two'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((StafetOpretHoldStepTwoDOM)=>{
            const component = createApp(StafetOpretHoldStepTwo).use(Store)
            component.mount(StafetOpretHoldStepTwoDOM)
        })
    }
}